import React from 'react'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { useToasts } from 'react-toast-notifications'
import useQuery from '_hooks/useQuery'
import useShareLinkEvent from '_hooks/useShareLinkEvent'
import { GMT_0, SHORT_DATE } from '_utils/constant'
import { getDateRemainFromNow } from '_utils/function'
import './style.scss'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

export default function OrderHeader({
  title,
  closingTimestamp,
  pickupTimestamp,
  closingTime,
  pickupTime,
  id,
  // eventAndOrderById,
}) {
  const history = useHistory()
  const { addToast } = useToasts()
  const query = useQuery()
  const isByAdmin = query.get('isByAdmin') === 'true'
  const { handleShare, isLoading: isLoadingShare } = useShareLinkEvent()

  const closingDate = closingTimestamp
    ? moment.unix(closingTimestamp).utcOffset(GMT_0).format(SHORT_DATE)
    : ''
  const collectionDate = pickupTimestamp
    ? moment.unix(pickupTimestamp).utcOffset(GMT_0).format(SHORT_DATE)
    : ''

  const closingRemain = closingTime ? getDateRemainFromNow(closingTime) : ''
  const deliveryRemain = pickupTime ? getDateRemainFromNow(pickupTime) : ''

  const closingCountdown = closingRemain ? `Closing in ${closingRemain}` : ''
  const deliveryCountdown = deliveryRemain ? `Delivery in ${deliveryRemain}` : ''

  const isClosingExpired = closingTime
    ? moment(closingTime, 'DD-MM-YYYY HH:mm').isBefore(moment())
    : false
  const isDeliveryExpired = pickupTime
    ? moment(pickupTime, 'DD-MM-YYYY HH:mm').isBefore(moment())
    : false

  const handleRehost = (e) => {
    e.preventDefault()

    if (isByAdmin) {
      addToast('You are not allowed to re-host this event', {
        appearance: 'error',
      })
      return
    }

    if (!id) return
    history.push(`/event/hosting?id=${id}&fromReHost=1`)
  }

  const handleShareClick = (e) => {
    e.preventDefault()
    if (isLoadingShare) return

    handleShare(id, (url) => {
      if (url) {
        navigator.clipboard.writeText(url)
        addToast('Link copied', { appearance: 'success', autoDismiss: true })
      }
    })
  }

  return (
    <div className="od-header">
      <div>
        <Link to={`/event/detail?eid=${id}`} >
          <div className="page-title" id="od-title">
            {title}
          </div>
        </Link>
        <p className="page-subtitle">
          Closing: <strong id="od-closing">{closingDate}</strong>
          {collectionDate && (
            <span id="od-collection-wrap">
              &nbsp;&nbsp;·&nbsp;&nbsp;Collection: <strong id="od-collection">{collectionDate}</strong>
            </span>
          )}
        </p>
      </div>
      <div className="od-meta-right">
        {isClosingExpired ? (
          <div className="od-countdown expired" id="od-countdown-closed">
            Closed
          </div>
        ) : (
          <>
            {closingCountdown && (
              <div className="od-countdown" id="od-countdown-closing">
                {closingCountdown}
              </div>
            )}
            {deliveryCountdown && (
              <div
                className={`od-countdown ${isDeliveryExpired ? 'expired' : ''}`}
                id="od-countdown-delivery"
              >
                {deliveryCountdown}
              </div>
            )}
          </>
        )}
        <div className="od-buttons">
          <div className="od-button-action" onClick={handleRehost}>
            Re-host
          </div>
          <span className="od-divider">·</span>
          <div
            className="od-button-action"
            onClick={handleShareClick}
            style={isLoadingShare ? { pointerEvents: 'none', opacity: 0.5 } : {}}
          >
            {isLoadingShare ? 'Loading...' : 'Share'}
          </div>
        </div>
      </div>
    </div>
  )
}
